var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVenderb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3756",
    "data-name": "Rectangle 3756",
    width: 24,
    height: 24,
    transform: "translate(60 479)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_4727",
    "data-name": "Mask Group 4727",
    transform: "translate(-60 -479)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wallet",
    transform: "translate(43.167 462.167)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mobile_Banking_1_",
    transform: "translate(24.342 20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8194",
    "data-name": "Path 8194",
    d: "M136,24.192V21.5a1.5,1.5,0,0,1,1.5-1.5h5.989a1.5,1.5,0,0,1,1.5,1.5v2.695",
    transform: "translate(-136 -20)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_779",
    "data-name": "Line 779",
    y1: 4.055,
    transform: "translate(3.043 0.145)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_780",
    "data-name": "Line 780",
    y1: 1.158,
    transform: "translate(5.94 3.041)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8195",
    "data-name": "Path 8195",
    d: "M20,172a1.5,1.5,0,0,0,1.5,1.5H34.672a1.5,1.5,0,0,1,1.5,1.5v1.5",
    transform: "translate(0 -146.311)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8196",
    "data-name": "Path 8196",
    d: "M36.169,142.48v1.5a1.5,1.5,0,0,1-1.5,1.5H21.5a1.5,1.5,0,0,1-1.5-1.5V133.5a1.5,1.5,0,0,1,1.5-1.5",
    transform: "translate(0 -107.808)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8197",
    "data-name": "Path 8197",
    d: "M336.491,296.491h-2.246a2.246,2.246,0,1,1,0-4.491h2.246a1.5,1.5,0,0,1,1.5,1.5v1.5A1.5,1.5,0,0,1,336.491,296.491Z",
    transform: "translate(-300.322 -261.819)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVenderb);
export default __webpack_public_path__ + "static/media/venderb.32670399a46926398ccc930bc446f77c.svg";
export { ForwardRef as ReactComponent };